// 系统相关配置

let conf ={

	// 本地测试地址
	// apiBaseUrl: 'http://192.168.0.24/',
	// apiBaseImg:'http://192.168.0.24'
	apiBaseUrl: 'http://www.cnqingxiji.com/index.php/',
	apiBaseImg:'http://www.cnqingxiji.com/public',
	// apiUrl: 'http://hunshui.xxcf.net/public/html/phone/index.html#/',
	// apiUrl: 'http://hunshui.xxcf.net/public/html/index.html#/indexMain',

}

module.exports = conf



// WEBPACK FOOTER //
// ./src/assets/js/settings.js